import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const postBuyAndSell = async (data) => {
  try {
    return await postData(`/website/buy-sell`, data);
  } catch (error) {
    console.log(error);
  }
};

export const postBuyAndSellPending = async (data) => {
  try {
    return await postData(`/website/buy-sell/pending`, data);
  } catch (error) {
    console.log(error);
  }
};

export const GetAllBuyAndSellPending = async (company_id) => {
  try {
    return await getData(
      `/website/buy-sell/all-pending?company_id=${company_id}`
    );
  } catch (error) {
    console.log(error);
  }
};

export const GetAllBuyAndSellPendingUpdate = async (data) => {
  try {
    return await postData(`/website/buy-sell/update-pending`, data);
  } catch (error) {
    console.log(error);
  }
};

export const closeTrades = async (id, data) => {
  try {
    return await postData(`/website/buy-sell/close-trade/${id}`, data);
  } catch (error) {
    console.log(error);
  }
};

export const deleteTrades = async (id) => {
  try {
    return await deleteData(`/website/buy-sell/delete-trade/${id}`);
  } catch (error) {
    console.log(error);
  }
};
